import React, { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as Styles from './Styles';
import Banner from './banner/Banner';
import Form from './form/Form';

type State = {};

class StartViewComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Banner />
				<Form />
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const MainView = connector(StartViewComponent);
export default MainView;
